import React from "react";
import SimpleMiningCalculator from "../Components/SimpleMiningCalculator";
import Animate from "../Components/Animate";

export default function Global() {
  return (
    <div className="p-[2px] max-w-4xl mx-auto font-sans bg-[#191A21] text-gray-100 min-h-screen">

     
      {/* Простой калькулятор */}
      <div className="w-full">
        <Animate>
          <SimpleMiningCalculator />
        </Animate>
      </div>

    </div>
  );
}
